export const onlyDigitsRegexp = /^[0-9]+$/;
export const specialRegexp = /[0-9\.,:;?!*+%\-<>@\[\]\{\}\\\/_$#]+/;
export const notAvailableSymbolRegexp = /[^a-zA-Z0-9\.,:;?!*+%\-<>@\[\]\{\}\\\/_$#]+/;
export const upperLatinRegexp = /[A-Z]+/;
export const lowerLatinRegexp = /[a-z]+/;
export const validEmailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
